import React from 'react';
import formatCurrencyService from '../Services/formatCurrencyService';

const ConfiguratorOptionPrice = ({ price, formatter }) => (
    <span className={ 'config-price' + (price > 0 ? ' config-price--positive' : '') }>{ price !== 0 ? formatCurrencyService.formatCurrency(formatter, price) : ""}</span>
)

export default ConfiguratorOptionPrice;